export default __webpack_public_path__ + "static/media/me.8208a588.png";